import appConfig from 'src/utils/appConfig';
import externalRouter from 'src/utils/externalRouter';
import { reportRegistrationFailure } from 'src/utils/rollbar';
import { CampaignsTracker, gtm } from 'marketing-tracker';
import http from './http';
import Promise from 'pinkie-promise';
import Cookies from 'js-cookie';

export default {
  create: function(user, registrationOptions) {
    const { goBaseUrl, locale } = appConfig.getMyConfig();
    const userAPIUrl = externalRouter.parse('apiV4UserCreate', { locale });

    return new Promise(function(resolve, reject) {
      function success(xhr) {
        const response = typeof xhr.data === 'object' ? xhr.data : JSON.parse(xhr.data);
        const createdUser = Object.assign({}, user, response.user);

        const campaignsTracker = new CampaignsTracker({ host: goBaseUrl });
        campaignsTracker.trackSimpleLead(createdUser.uuid);

        gtm.trackSimpleLead({
          leadDate: createdUser.registration_date,
          learnLanguageAlpha3: createdUser.learn_language_alpha3,
          uuid: createdUser.uuid
        });

        resolve({ user: createdUser, userCreated: true });
      }

      function failure(xhr) {
        const response = typeof xhr.response === 'object' ? xhr.response : JSON.parse(xhr.response);
        if (response.status === 422) {
          const responseErrors = response.data.error.messages.reduce(function(memo, error) {
            if (user.hasOwnProperty(error.attribute)) {
              memo[error.attribute] = error.message;
            }
            return memo;
          }, {});

          if (Object.keys(responseErrors).length !== 0) {
            reject({ user: user, error: responseErrors });
          } else {
            resolve({ user: user });
          }
        } else {
          reportRegistrationFailure(response.data.error, response.status);
          reject(new Error('registration:failed'));
        }
      }

      http.post(
        userAPIUrl,
        { user },
        { registrationOptions: registrationOptions,
          headers: {
          'X-Babbel-Tracking-UUID': Cookies.get('babbeltrackinguuid')
          }
        }
      ).then(success, failure);
    });
  },

  getCurrentUser: function() {
    const locale = appConfig.getMyConfig().locale;
    const userAPIUrl = externalRouter.parse('apiV4UserShow', { locale });

    return new Promise(function(resolve) {
      function success(xhr) {
        resolve(JSON.parse(xhr).user);
      }

      http.get(userAPIUrl).then(success);
    });
  }
};
